import { Api } from "@/types/Api";

// Create API instance
const apiInstance = new Api('/api/v1');

// Try to restore token from localStorage on initialization
const cachedToken = localStorage.getItem('portal-api-token');
if (cachedToken) {
    console.log('[API Init] Found cached token in localStorage, setting on API instance');
    apiInstance.setToken(cachedToken);
} else {
    console.log('[API Init] No cached token found in localStorage');
}

// Add a helper to check authentication status
export function checkAuthStatus() {
    const token = localStorage.getItem('portal-api-token');
    console.log('[Auth Status]', {
        hasLocalStorageToken: !!token,
        hasApiToken: !!apiInstance.token,
        tokensMatch: token === apiInstance.token,
        tokenPreview: token ? token.substring(0, 20) + '...' : 'none'
    });
}

// Call it on init
if (process.env.NODE_ENV === 'development') {
    checkAuthStatus();
}

export const api = apiInstance;